<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel120">Process Settlement</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="form form-horizontal" >
            <div class="row">
              <div class="col-12">
               <div v-if="successTransactionId" class="text-center">
                 <h3>Transaction Success</h3>
                 <h4 class="text-success font-weight-bolder">{{successTransactionId}}</h4>
               </div>
                <div v-else>
                  <div class="form-group row">
                    <div class="col-12 col-form-label">
                      <label>Reference(Optional)</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12">
                      <div class="input-group">
                        <input
                            class="form-control"
                            type="text"
                            name="amount"
                        >
                      </div>
                    </div>
                  </div>
                    <div class="form-group row d-flex justify-content-end">
                      <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loader"
                      >
                        <Loader :loading="loader" size="10px"></Loader>
                        Process
                      </button>
                    </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'settlementId',"row","index",'vuexKey'],
  data() {
    return {
      list: [],
      loader:false,
      reference : '',
      successTransactionId:false
    }
  },
  mounted() {
  },
  methods: {
    sendCall() {
      this.loader = true
      this.makeRequest('post', 'v1/process-settlement', {settlementId:this.settlementId,reference: this.reference}).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.successTransactionId = callResponse.response.data.data.transactionId
            let data = {
              index: this.index,
              row: this.row,
              key: this.vuexKey
            };
            data.row.status = 3
            let storeData = this.$store.getters.getByKey(this.vuexKey);
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                    typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                    typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = this.vuexKey;
              this.$store.dispatch("set", storeData);
            }
            this.$emit('processSuccess')
          }
        }

      });

    },
  },
}
</script>

<style scoped>

/*--thank you pop starts here--*/
.thank-you-pop{
  width:100%;
  padding:20px;
  text-align:center;
}
.thank-you-pop img{
  width:76px;
  height:auto;
  margin:0 auto;
  display:block;
  margin-bottom:25px;
}

.thank-you-pop h1{
  font-size: 42px;
  margin-bottom: 25px;
  color:#5C5C5C;
}
.thank-you-pop p{
  font-size: 20px;
  margin-bottom: 27px;
  color:#5C5C5C;
}
.thank-you-pop h3.cupon-pop{
  font-size: 25px;
  margin-bottom: 40px;
  color:#222;
  display:inline-block;
  text-align:center;
  padding:10px 20px;
  border:2px dashed #222;
  clear:both;
  font-weight:normal;
}
.thank-you-pop h3.cupon-pop span{
  color:#03A9F4;
}
.thank-you-pop a{
  display: inline-block;
  margin: 0 auto;
  padding: 9px 20px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  background-color: #8BC34A;
  border-radius: 17px;
}
.thank-you-pop a i{
  margin-right:5px;
  color:#fff;
}
#ignismyModal .modal-header{
  border:0px;
}
/*--thank you pop ends here--*/

</style>

